import { FeeConfigurationInterface } from '@/interfaces/FeeStructures.interface';
import BaseApiClient from '../BaseApiClient';

export class ApiFeeAllocations extends BaseApiClient {
  /**
   * Create fee allocation
   */
  async create(
    feeConfigurationId: number,
    payload: {
      value: number;
      fee_beneficiary_type_id: number;
    }
  ): Promise<FeeConfigurationInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/fee-configurations/${feeConfigurationId}/fee-allocations`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Update fee allocation
   */
  async update(feeAllocationId: number, payload: {
    value: number;
    fee_beneficiary_type_id: number;
  }): Promise<FeeConfigurationInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/fee-allocations/${feeAllocationId}`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Delete fee allocation
   */
  async delete(feeAllocationId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/fee-allocations/${feeAllocationId}`, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.status === 204) {
            resolve();
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { feeAllocationsQueryKeys } from './query-keys';
export {
  useFeeAllocationsCreateMutation,
  useFeeAllocationsDeleteMutation,
  useFeeAllocationsUpdateMutation
} from './use-fee-allocations-mutations';
export type {
  FeeAllocationsCreateVariables,
  FeeAllocationsUpdateVariables
} from './use-fee-allocations-mutations';
